export const notificationInitialState = () => ({ owner: '', epoch: 0, revision: 0, items: [], unread: 0, through: null, next: null, filter: 'all', loading: false, writing: false, error: '', readError: '', countError: false });
// Framework-independent controller: tested with deferred responses to reject stale counts/account data.
export function createNotificationController(state, request) {
    const s = () => state();
    let countFlight = null, listFlight = null;
    function sync(owner) { owner = String(owner || ''); if (s().owner === owner)
        return; const epoch = s().epoch + 1; Object.assign(s(), notificationInitialState(), { owner, epoch }); countFlight = null; listFlight = null; }
    async function count() { if (!s().owner || countFlight)
        return; const ticket = { epoch: s().epoch, revision: s().revision }; countFlight = ticket; try {
        const result = await request('/api/notifications', { query: { count: '1' } });
        if (ticket.epoch === s().epoch && ticket.revision === s().revision) {
            s().unread = result.unread;
            s().countError = false;
        }
    }
    catch {
        if (ticket.epoch === s().epoch && ticket.revision === s().revision)
            s().countError = true;
    }
    finally {
        if (countFlight === ticket)
            countFlight = null;
    } }
    async function load(more = false) { if (!s().owner || listFlight)
        return; const ticket = { epoch: s().epoch, revision: s().revision, filter: s().filter }; listFlight = ticket; s().loading = true; s().error = ''; try {
        const result = await request('/api/notifications', { query: { filter: ticket.filter, ...(more && s().next ? { before: s().next } : {}) } });
        if (ticket.epoch !== s().epoch || ticket.revision !== s().revision || ticket.filter !== s().filter)
            return;
        const rows = more ? [...s().items, ...result.items] : result.items;
        s().items = [...new Map(rows.map(x => [x.id, x])).values()];
        s().unread = result.unread;
        s().through = result.through;
        s().next = result.next;
        s().countError = false;
    }
    catch {
        if (ticket.epoch === s().epoch && ticket.revision === s().revision && ticket.filter === s().filter)
            s().error = 'Не удалось загрузить уведомления. Попробуйте ещё раз.';
    }
    finally {
        if (listFlight === ticket) {
            listFlight = null;
            s().loading = false;
        }
    } }
    async function read(item = null) {
        if (!s().owner || s().writing)
            return false;
        if (!item && !s().through)
            return true;
        const epoch = s().epoch, wasUnread = !!item?.unread;
        s().writing = true;
        s().readError = '';
        s().revision++;
        countFlight = null;
        listFlight = null;
        s().loading = false;
        try {
            const acknowledged = await request('/api/notifications/read', { method: 'POST', body: item ? { ids: [item.id] } : { through: s().through } });
            if (!acknowledged?.saved)
                throw Error('Missing acknowledgement');
            if (epoch !== s().epoch)
                return false;
            for (const row of s().items)
                if (!item || row.id === item.id)
                    row.unread = false;
            if (item)
                s().unread = Math.max(0, s().unread - (wasUnread ? 1 : 0));
            else
                s().unread = 0;
            // Read acknowledgement does not cover notifications arriving after the list snapshot.
            await count();
            if (epoch === s().epoch && s().filter === 'unread')
                await load();
            return true;
        }
        catch {
            if (epoch === s().epoch)
                s().readError = 'Не удалось отметить уведомления прочитанными. Повторите попытку.';
            return false;
        }
        finally {
            if (epoch === s().epoch)
                s().writing = false;
        }
    }
    return { sync, count, load, read };
}
export function notificationTime(value, now = Date.now()) {
    const date = new Date(value);
    if (!Number.isFinite(date.getTime()))
        return '';
    const seconds = Math.max(0, (now - date.getTime()) / 1000);
    if (seconds < 60)
        return 'Только что';
    if (seconds < 3600)
        return Math.floor(seconds / 60) + ' мин назад';
    if (seconds < 86400)
        return Math.floor(seconds / 3600) + ' ч назад';
    return new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'short', timeZone: 'Europe/Moscow' }).format(date);
}
